import {useCallback, useState} from 'react';

import {LookupConfigSpec} from 'lookup-config/LookupConfigModalConstants';
import {MinimalEntity} from 'ui-library/entity-input/EntityInputConstants';

import {
  getMinimalEntitiesFromResponsibleParties,
  getResponsiblePartyLookupConfig,
} from './ProcessTaskSchemaEditorUtils';
import type {MinimalProcessTaskSchema, UpdateProcessSchema} from './ProcessTaskSchemaUtils';

export interface ResponsiblePartiesState {
  defaultResponsibleParties: Array<MinimalEntity>;
  areDefaultResponsiblePartiesValid: boolean;
  showDefaultResponsiblePartiesError: boolean;
  responsiblePartyLookupConfig: LookupConfigSpec | null;

  setAreDefaultResponsiblePartiesValid: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDefaultResponsiblePartiesError: React.Dispatch<React.SetStateAction<boolean>>;

  applyResponsiblePartiesUpdates: (params: UpdateProcessSchema) => void;
}

export function useResponsiblePartiesState(
  processTaskSchema: MinimalProcessTaskSchema | null
): ResponsiblePartiesState {
  const [defaultResponsibleParties, setDefaultResponsibleParties] = useState<Array<MinimalEntity>>(
    getMinimalEntitiesFromResponsibleParties(processTaskSchema?.responsibleParties ?? [])
  );
  const [areDefaultResponsiblePartiesValid, setAreDefaultResponsiblePartiesValid] = useState(true);
  const [showDefaultResponsiblePartiesError, setShowDefaultResponsiblePartiesError] = useState(false);
  const [responsiblePartyLookupConfig, setResponsiblePartyLookupConfig] = useState<LookupConfigSpec | null>(
    getResponsiblePartyLookupConfig(processTaskSchema?.responsiblePartyLookupConfigs ?? [])
  );

  const applyResponsiblePartiesUpdates = useCallback((params: UpdateProcessSchema): void => {
    if (params.defaultResponsibleParties !== undefined) {
      setDefaultResponsibleParties(params.defaultResponsibleParties);
    }
    if (params.responsiblePartyLookupConfig !== undefined) {
      setResponsiblePartyLookupConfig(params.responsiblePartyLookupConfig);
    }
  }, []);

  return {
    defaultResponsibleParties,
    areDefaultResponsiblePartiesValid,
    showDefaultResponsiblePartiesError,
    responsiblePartyLookupConfig,

    setAreDefaultResponsiblePartiesValid,
    setShowDefaultResponsiblePartiesError,

    applyResponsiblePartiesUpdates,
  };
}
